// useEtiquettes.ts
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys";
import EtiquetteService from "@/integrations/service/etiquette.service";

export const useEtiquettes = () => {
  return useQuery({
    queryKey: queryKeys.etiquettes,
    queryFn: EtiquetteService.getAll,
  });
};

export const useCreateEtiquette = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: EtiquetteService.create,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.etiquettes });
    },
  });
};

export const useUpdateEtiquette = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: any) =>
      EtiquetteService.update(id, payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.etiquettes });
    },
  });
};

export const useDeleteEtiquette = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: EtiquetteService.delete,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.etiquettes });
    },
  });
};